<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.usuario_id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Unidades Vinculadas
							<i class="fa fa-bulding"></i>
                            <span v-if="rowData.usuario_bcliente_global">(* Apenas da Empresa Conectada) </span>
						</span>
					</a>
				</li>
                <li class="nav-item">
                    <a class="nav-link" v-if="rowData.usuario_bcliente||rowData.usuario_bcliente_global" v-bind:href="'#t4'+rowData.usuario_id+''" role="tab" data-toggle="tab">
                        <span class="nav-link-in">
                            Empresas Vinculadas
                            <i class="fa fa-bulding"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-if="rowData.model_has_roles.length>0" v-bind:href="'#t2'+rowData.usuario_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Roles de acesso
                      <i class="fa fa-key"></i>
                    </span>
                  </a>
                </li>
                <!-- <li class="nav-item">
                  <a class="nav-link" v-if="rowData.model_has_roles.length>0" v-bind:href="'#t3'+rowData.usuario_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Permissões via roles
                      <i class="fa fa-key"></i>
                    </span>
                  </a>
                </li> -->
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show" v-bind:id="'t1'+rowData.usuario_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 70%">Unidade</th>
                                <th style="width: 20%">Status</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody v-if="rowData.rel_unidade_usuario.length>0">
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.rel_unidade_usuario">
                                <td>
                                    {{ item.unidade.cd }} {{ item.unidade.descr }}
                                </td>
                                <td>
                                    <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                    <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                </td>
                                <td>
                                    <a v-if="item.status.valor==2" @click="onActivateDesactivate(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                    <a v-if="item.status.valor==1" @click="onActivateDesactivate(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade" v-if="rowData.usuario_bcliente||rowData.usuario_bcliente_global" v-bind:id="'t4'+rowData.usuario_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 70%">Empresa</th>
                                <th style="width: 20%">Status</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.usuario_bcliente">
                                <td>
                                    {{ item.bcliente.cd }} - {{ item.bcliente.nome }}
                                </td>
                                <td>
                                    <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                    <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                </td>
                                <td>
                                    <a v-if="item.status.valor==2" @click="onActivateDesactivateEmpresa(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                    <a v-if="item.status.valor==1" @click="onActivateDesactivateEmpresa(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.usuario_bcliente_global">
                               <td>
                                   {{ item.bcliente_global.cd }} - {{ item.bcliente_global.nome }}
                               </td>
                               <td>
                                   <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                   <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                               </td>
                               <td>
                                   <a v-if="item.status.valor==2" @click="onActivateDesactivateEmpresa(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                   <a v-if="item.status.valor==1" @click="onActivateDesactivateEmpresa(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                               </td>
                           </tr>
                       </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade"  v-if="rowData.model_has_roles.length>0" v-bind:id="'t2'+rowData.usuario_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 20%">Empresa</th>
                                <th style="width: 20%">Role</th>
                                <th style="width: 10%">Data inclusão</th>
                                <th style="width: 30%">Detalhes</th>
                                <th style="width: 10%">Ação</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.model_has_roles">
                                 <td>
                                     <span v-if="item.role">
                                         {{ item.role.bcliente.nome }}
                                     </span>
                                     <span v-if="item.roles_global">
                                         {{ item.roles_global.bcliente_global.nome }}
                                     </span>
                                </td>
                                <td>
                                    <span v-if="item.role">
                                        {{ item.role.name }}
                                    </span>
                                    <span v-if="item.roles_global">
                                        {{ item.roles_global.name }}
                                    </span>
                                </td>
                                <td>
                                    {{ item.dt_inc }}
                                </td>
                                <td>
                                    <span v-if="item.role">
                                        {{ item.role.descr }}
                                    </span>
                                    <span v-if="item.roles_global">
                                        {{ item.roles_global.descr }}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.role">
                                        <a v-if="getPermission('usuario.role.destroy')" @click="onDestroyRole(item.role.id, rowData.usuario_id)" v-b-tooltip title="Remover"><i class="fa fa-trash"></i></a>
                                    </span>
                                    <span v-if="item.roles_global">
                                        <a v-if="getPermission('usuario.role.destroy')" @click="onDestroyRole(item.roles_global.id, rowData.usuario_id)" v-b-tooltip title="Remover"><i class="fa fa-trash"></i></a>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade"  v-if="rowData.model_has_roles.length>0" v-bind:id="'t2'+rowData.usuario_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 20%">Role</th>
                                <th style="width: 10%">Data inclusão</th>
                                <th style="width: 30%">Detalhes</th>
                                <th style="width: 10%">Ação</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.model_has_roles">
                                 <td>
                                     <span v-if="item.role">
                                         {{ item.role.name }}
                                     </span>
                                     <span v-if="item.roles_global">
                                         {{ item.roles_global.name }}
                                     </span>
                                 </td>
                                 <td>
                                     {{ item.dt_inc }}
                                 </td>
                                 <td>
                                     <span v-if="item.role">
                                         {{ item.role.descr }}
                                     </span>
                                     <span v-if="item.roles_global">
                                         {{ item.roles_global.descr }}
                                     </span>
                                 </td>
                                <td>
                                    <span v-if="item.role">
                                        <a v-if="getPermission('usuario.role.destroy')" @click="onDestroyRole(item.role.id, rowData.usuario_id)" v-b-tooltip title="Remover"><i class="fa fa-trash"></i></a>
                                    </span>
                                    <span v-if="item.roles_global">
                                        <a v-if="getPermission('usuario.role.destroy')" @click="onDestroyRole(item.roles_global.id, rowData.usuario_id)" v-b-tooltip title="Remover"><i class="fa fa-trash"></i></a>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t3'+rowData.usuario_id+''" v-if="rowData.model_has_roles.length>0">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 20%">Permissão</th>
                                <th style="width: 30%">Descrição</th>
                                <th style="width: 10%">Tipo</th>
                                <th style="width: 10%">Via Role:</th>
                            </tr>
                         </thead>
                         <tbody v-for="item_model in rowData.model_has_roles" v-if="rowData.model_has_roles[0].role">
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in item_model.role.role_has_permissions">
                                 <td>
                                     {{ item.permission.name }}
                                 </td>
                                 <td>
                                     {{ item.permission.descr }}
                                 </td>
                                 <td>
                                     {{ item.permission.tp_permission.descr }}
                                 </td>
                                 <td>
                                     {{ item_model.role.descr }}
                                 </td>
                            </tr>
                        </tbody>
                        <tbody v-for="item_model in rowData.model_has_roles" v-if="rowData.model_has_roles[0].roles_global">
                            <tr class="bg-gray-light" style="display: table-row;" v-if="item_model.roles_global" v-for="item in item_model.roles_global.role_has_permissions">
                                <td>
                                    {{ item.permission.name }}
                                </td>
                                <td>
                                    {{ item.permission.descr }}
                                </td>
                                <td>
                                    {{ item.permission.tp_permission.descr }}
                                </td>
                                <td>
                                    {{ item_model.roles_global.descr }}
                                </td>
                           </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: [], role_id: "", usuario_id: ""}),
        }
    },

    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onDestroyRole(role_id, usuario_id)
        {
            this.helpForm.role_id = role_id;
            this.helpForm.usuario_id = usuario_id;
            this.helpForm.post('/api/usuario/role/destroy').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivate(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.runidusu_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.post('/api/usuario/unidade/status').then(response =>
            {
                new ReturnApi(response, this)
                Event.$emit('reloadVuetable', data);
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onActivateDesactivateEmpresa(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.usubcl_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }

            this.helpForm.post('/api/usuario/bcliente/status').then(response =>
            {
                new ReturnApi(response, this)
                Event.$emit('reloadVuetable', data);
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
  }
  </script>
